import React, { useState, useEffect } from "react";
import "./App.css";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import Loader from "./services/Loader/Loader";
import getDataFromAPI from "./services/getDataFromAPI";
import CardDetail from "./components/CardDetail/CardDetail";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Header from "./components/Header/Header";
import axios from "./services/axios";
import { ClickAwayListener } from "@material-ui/core";

import PlayerTrailer from "./components/PlayerTrailer/PlayerTrailer";

import PlayerShow from "./components/PlayerShow/PlayerShow";

import PlayerShare from "./components/PlayerShare/PlayerShare";

function App() {
  window.dataLayer.push({
    event: 'pageview'
  });
  //STATE VARS
  const [isLoading, setLoading] = useState(true); //true while APi is fetching
  const [assets, setAssets] = useState([]); // empty since API return data
  const [filterValue, setFilterValue] = useState("");
  const [lang, setLang] = useState("cat");
  const [isLogged, setIsLogged] = useState(false);
  const [click, setClick] = useState(false);
  // const [externalToken,setExternalToken]=useState("");

  // // user como contexto..
  // const user = {
  //   email: "",
  //   token: "",
  //   expiratonDate: Date,
  //   hasMemberShips: false,
  // };
  //GET DATA
  useEffect(() => {
    getDataFromAPI(lang).then((data) => {
      setAssets(data);
      setLoading(false);
    });
    return;
    /*axios.get(`/allasset/lang/${lang}`)
  .then((response) => {
    //console.log(response.data);
    setAssets(response.data);
    setLoading(false);
  });*/
  return;
  }, [lang]);

  //HANDLE KOOBIN RESPONSE
  const handleResponse = ({ match, history }) => {
    let { id, token } = match.params;

    // console.log("id", id);
    // console.log("token", token);

    axios
      .get(`/validatetoken?koobinToken=${token}`)
      .then((resp) => {
        //respuesta con email, hasmemberShip, token
        if (resp.data) {
          console.log(resp.data);
          // localStorage.setItem("expirationDate", resp.data.expirationDate);
          localStorage.setItem("hasMemberShips", resp.data.hasMemberships);
          localStorage.setItem("token", resp.data.accessToken);
          localStorage.setItem("email", resp.data.email);
          localStorage.setItem("rol",resp.data.rol);
          isLoggedFunc(true);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    //eventID puede estar o no.
    if (id === undefined) {
      //set external token to validate in home component
      //setExternalToken(token);
      history.push("/home");
    } else {
      //setExternalToken(token);
     // id = id.slice(1, -1);
      history.push(`/ppv/${id}`);
    }
  };

  //HANDLE URL CARD DETAIL
  const handleDetail = (props) => {
    const assetClicked = assets.find((asset) => {
      return asset.thirdPartyId === props.match.params.id;
    });
    //comprobar errores ruta??
    return !!assetClicked ? (
      <CardDetail lang={lang} isLogged={isLogged} info={assetClicked} />
    ) : (
      <Loader />
    );
  };

  //HANDLE LOGIN
  const isLoggedFunc = (value) => {
    console.log("login", value);
    setIsLogged(value);
    if (value === false) {
      localStorage.clear();
    }
  };
  //HANDLE LANG
  const handleLang = (newlang) => {
    // console.log(lang);
    // console.log("en app, ", newlang);
    setLang(newlang);
  };

  //HANDLE FILTER
  const handleFilter = (key) => {
    setFilterValue(key);
  };

  //filtro buscador
  const filteredAssets = assets.filter((asset) => {
    let found = false;
    if (asset.title?.toUpperCase().includes(filterValue.toUpperCase()))
      //stringVacio siempre da true
      found = true;
    if (asset.subtitle?.toUpperCase().includes(filterValue.toUpperCase()))
      found = true;
    if (asset.eventDetail?.toUpperCase().includes(filterValue.toUpperCase()))
      found = true;
    if (asset.description?.toUpperCase().includes(filterValue.toUpperCase()))
      found = true;

    if(asset.staff !== null)
    {
    asset.staff.forEach((element) => {
      if (
        element.personName.toUpperCase().includes(filterValue.toUpperCase())
      ) {
        //console.log("true", asset.title);
        found = true;
      }
    });
  }
    if (asset.recommendedAge?.includes(filterValue)) found = true;

    asset.idiomList.forEach((element) => {
      if (element.idiomName !== "") {
        if (
          element.idiomName
            .toUpperCase()
            .includes(filterValue.toLocaleUpperCase())
        )
          found = true;
      }
    });

    asset.subtitleList.forEach((element) => {
      if (!!element.subtitleName)
        if (
          element.subtitleName
            .toUpperCase()
            .includes(filterValue.toLocaleUpperCase())
        )
          found = true;
    });

    // console.log("found", found, asset.title);
    return found;
  });

  return (
    // BEM
    // <UserContext.Provider value={user}>
    <div className="app">
      {/* <Router basename="tnc"> */}
      <Router basename="educatiuprofessionals">
      <Header
              lang={lang}
              handleFilter={handleFilter}
              handleLang={handleLang}
              isLoggedFunc={isLoggedFunc}
              isLogged={isLogged}
            />

        <Switch>
      
          {/* <Route exact path="/search">
            <SearchPage />
          </Route> */}
           <Route exact path="/player/:assetId">
              {<PlayerShow />}
          </Route>
           <Route exact path="/trailer/:assetId">
              {<PlayerTrailer />}
        </Route>
          <Route exact path="/share/:assetId/vision/:visionId">
              {<PlayerShare />}
        </Route>
          <Route
            path="/response/eventId=:id&&accessToken=:token"
            render={handleResponse}
          />
          <Route path="/response/accessToken=:token" render={handleResponse} />
          
          <Route path="/response/eventId=:id" render={handleDetail} />

          <Route
            exact
            path="/ppv/:id"
            isLogged={isLogged}
            render={handleDetail}
          />
          {/* <Route
            exact
            path="/detail/:id"
            isLogged={isLogged}
            render={handleDetail}
          /> */}

          <Route exact path="/home">
            {isLoading ? (
              <Loader />
            ) : (
             <> 
           
              <Home
                lang={lang}
                handleFilter={handleFilter}
                assets={filteredAssets}
              />
                {/*<Footer lang={lang} />*/}
              </>
            )}
          </Route>

          <Route exact path="/">
            {isLoading ? (
              <Loader />
            ) : (
              <>
            
              <Home
                lang={lang}
                handleFilter={handleFilter}
                assets={filteredAssets}
              />
               
              </>
            )}
          </Route>
        </Switch>
        <Footer lang={lang} />
      
      </Router>
     
    </div>
    // </UserContext.Provider>
  );
}

export default App;
